import React, { useRef, useState, useEffect } from 'react';
// Redux
import { useSelector, useDispatch } from 'react-redux';
// Slices
import {
	setJobFetched,
} from '../../app/features/jobsSlice';
// Images
import { FaChevronDown } from 'react-icons/fa';
import { IoChevronBack } from 'react-icons/io5';
import { IoLocationOutline } from 'react-icons/io5';
import defaultImg from '../../Images/JobsPage/default.png';
import searchJobsIcon from '../../Images/JobsPage/searchjobs.png';
// Styles
import './JobDetail.css';
// Translate
import { useTranslation } from 'react-i18next';
// Utils
import { publicationDate } from '../../utils/publicationDate';

const JobDetail = ({language}) => {
	const { t } = useTranslation();
	const divRef = useRef(null);

	const { jobFetched } = useSelector((state) => state.jobs);
	const [viewMoreDetails, setViewMoreDetails] = useState(false);

	useEffect(() => {
		if (divRef.current) {
			divRef.current.scrollTop = 0;
		}
	}, [jobFetched]);

	const dispatch = useDispatch();
	const showDetailJobView = () => {
		if (jobFetched !== null && jobFetched !== undefined) {
			for (var key in jobFetched) {
				if (jobFetched.hasOwnProperty(key)) {
					return true;
				}
			}
		} else {
			return false;
		}
	};

	if (showDetailJobView()) {
		return (
			<section
				ref={divRef}
				className='jobDescriptionContainer scroll-containerDetail'
			>
				<section className='jobDescriptionContainer__summary'>
					<button
						className='backButton'
						onClick={() => dispatch(setJobFetched({}))}
					>
						<IoChevronBack />
						{t('Back')}
					</button>
					<div className='jobDescriptionContainer_img_content'>
						<div className='jobDescriptionContainer__content'>
							<img
								alt='IMG'
								src={jobFetched.thumbnail ? jobFetched.thumbnail : defaultImg}
							/>
							<div className='contentInfo'>
								<h2>{jobFetched.title}</h2>
								<div>
									{(jobFetched.detected_extensions?.schedule_type ||
										jobFetched.detected_extensions?.work_from_home) && (
										<p className='jobDescriptionContainer__description time'>
											{t(jobFetched.detected_extensions?.schedule_type)}
											{jobFetched.detected_extensions?.work_from_home &&
												`, ${t('remote')}`}
										</p>
									)}
									{jobFetched.detected_extensions?.posted_at && (
										<p className='jobDescriptionContainer__description publication'>
											{t('Published')}
											: {publicationDate(jobFetched.detected_extensions?.posted_at, language)}
										</p>
									)}
								</div>

								<div>
									<h3 className='jobDescriptionContainer__company'>
										{jobFetched.company_name}
									</h3>
									<p className='jobDescriptionContainer__description'>
										<IoLocationOutline className='locationIcon' />
										{t(jobFetched.location)}
									</p>
								</div>
								<p>{jobFetched.detected_extensions?.salary}</p>
							</div>
						</div>
					</div>

					<div className='applyJobsContainer'>
						<p>{t('Apply for this vacancy here')}:</p>
						{jobFetched?.apply_options.length === 0 && (
							<span className='loader'></span>
						)}
						<div className='applyJobOptions'>
							{jobFetched?.apply_options?.map((apply, i) => {
								return (
									<a key={i} href={apply.link} target='_blank' rel='noreferrer'>
										{apply.title}
									</a>
								);
							})}
						</div>
					</div>
				</section>

				{/* Sección de detalle completo */}
				<section className='jobDescriptionContainer__detail'>
					{jobFetched?.job_highlights?.length > 0 && (
						<section className='experienceSection'>
							{jobFetched?.job_highlights?.map((highlight, i) => (
								<div key={i}>
									<h3 className='jobDescriptionContainer__detailTitle'>
										{highlight.title}:
									</h3>
									<ul>
										{highlight.items?.map((item, i) => (
											<li key={i}>{item}</li>
										))}
									</ul>
								</div>
							))}
						</section>
					)}

					<section className='summarySection'>
						<h3 className='jobDescriptionContainer__detailTitle'>
							{t('Employment summary')}
						</h3>
						<p>
							{t('Job')}:{' '}
							<span>{jobFetched.title}</span>
						</p>

						{jobFetched.detected_extensions?.schedule_type && (
							<p>
								{t('Working time')}
								: <span>{t(jobFetched.detected_extensions.schedule_type)}</span>
							</p>
						)}

						{jobFetched.detected_extensions?.work_from_home && (
							<p>
								{t('Workplace')}:{' '}
								<span>
									{jobFetched.detected_extensions.work_from_home && `, ${t('Remote')}`}
								</span>
							</p>
						)}

						{jobFetched.detected_extensions?.salary && (
							<p>
								{t('Salary')}:{' '}
								<span>{jobFetched.detected_extensions?.salary}</span>
							</p>
						)}
					</section>

					<section className='moreDetailsSection'>
						<div>
							<button
								className='viewMoreDetailsButton'
								onClick={() => {
									if (viewMoreDetails) {
										window.scrollTo(0, 0);
										window.scrollTo(0, 400);
									}
									setViewMoreDetails(!viewMoreDetails);
								}}
							>
								{t('View')}{' '}
								{viewMoreDetails
									? t('less')
									: t('more')}
								{' '}{t('details')}
							</button>
							<FaChevronDown
								className={
									viewMoreDetails
										? 'viewMoreDetailsButton iconActive'
										: 'viewMoreDetailsButton'
								}
							/>
						</div>

						{viewMoreDetails && (
							<div className='moreDetailsDescription'>
								<pre>{jobFetched.description}</pre>
							</div>
						)}
					</section>
				</section>
			</section>
		);
	} else {
		return (
			<div className='searchJobsDetail'>
				<img src={searchJobsIcon} alt='search jobs icon' />
				<p>{t('To view details select the job you are interested in')}</p>
			</div>
		);
	}
};

export default JobDetail;
